import { useState } from 'react'

import { faCircleXmark, faFilter } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dropdown } from 'antd'
import { useSelector } from 'react-redux'

import IconButton from './IconButton'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'

const FilterButton = ({ children, filterCount = 0, onReset }) => {
  const t = useSelector(selectTranslate)

  const [hovered, setHovered] = useState(false)

  return (
    <Dropdown
      overlay={children}
      overlayClassName='custom-overlay'
      trigger={['click']}
    >
      <div
        className='filter-button-wrapper'
        style={{ position: 'relative', display: 'inline-block' }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {filterCount > 0 && hovered && (
          <span
            aria-hidden
            style={{
              position: 'absolute',
              right: '7px',
              top: '5px',
              zIndex: '100',
              cursor: 'pointer'
            }}
          >
            <FontAwesomeIcon
              size='xl'
              onClick={(e) => {
                onReset()
                e.stopPropagation()
              }}
              icon={faCircleXmark}
            />
          </span>
        )}

        <IconButton
          className='flex-button'
          icon={faFilter}
          text={filterCount > 0 ? `${filterCount} ${filterCount === 1 ? t('filters.count.filter') : t('filters.count.filters')}` : ''}
          style={filterCount > 0 ? { color: '#52c41a', borderColor: '#52c41a' } : {}}
        />
      </div>
    </Dropdown>
  )
}

export default FilterButton
